import themeGet from '@styled-system/theme-get';
import styled, { css } from 'styled-components';

import { Link as LinkUnited } from '@olist/united';

export const Faq = styled.section`
  h3 {
    margin-bottom: 30px;
    text-align: center;
    max-width: 900px;
    strong {
      color: #364ef7;
      font-weight: bold;
    }
  }
  .content {
    background: #364ef7;
    border-radius: 15px;
    margin: 0 auto;
    max-width: 900px;
    padding: 20px;
  }

  .tab {
    background: white;
    border-radius: 15px;
    margin-bottom: 10px;
    .text {
      font-size: 14px;
      height: 0;
      line-height: 18px;
      overflow: hidden;
      transition: 0.3s;
      > div {
        padding: 20px;
        padding-top: 0;
      }
    }
  }

  .title_tab {
    align-items: center;
    cursor: pointer;
    display: flex;
    justify-content: flex-start;
    padding: 20px;
    position: relative;
    position: relative;
    &:after {
      border: 2px solid #263238;
      border-bottom: 0px;
      border-right: 0px;
      content: '';
      font-size: 16px;
      font-weight: 600;
      height: 8px;
      line-height: 15px;
      margin-right: 10px;
      margin-top: -6px;
      position: absolute;
      right: 12px;
      top: 50%;
      transform: rotate(-135deg);
      transition: 0.3s;
      width: 8px;
    }
  }
  .contact {
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }
  .active {
    &:after {
      transform: rotate(45deg);
    }
    .text {
      height: auto;
    }
  }
`;

export const Container = styled.div`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 0 auto;
  max-width: 1440px;
  padding: 0 80px;
  ${({ theme }) => {
    return (
      theme &&
      css`
        @media (max-width: ${theme.breakpoints.medium}) {
          padding: 0 16px;
          flex-direction: column;
        }
      `
    );
  }}
`;

export const Link = styled(LinkUnited)`
  background-color: #0c29d0;
  border: 1px solid #0c29d0;
  border-radius: ${themeGet('olist.borderRadius.pill')};
  color: #ffffff;
  display: flex;
  height: 48px;
  padding: 0px 24px;
  &:hover {
    background-color: #0c29d0 !important;
    border: 1px solid #0c29d0 !important;
    box-shadow: none !important;
    color: #ffffff !important;
    svg {
      margin-left: 10px;
      width: 12px;
    }
  }
  svg {
    display: block;
    margin-left: 0px;
    overflow: hidden;
    transition: 0.3s;
    width: 0;
    path {
      fill: #ffffff !important;
    }
  }
  a {
    color: #ffffff;
    text-decoration: none;
  }
`;
